import { type ChakraV3, PhoneNumberInput } from '@piccolohealth/ui';
import React from 'react';
import { useController } from 'react-hook-form';

interface Props extends Omit<ChakraV3.InputProps, 'value' | 'onChange'> {
  name: string;
}

export const HookedPhoneNumberInput = (props: Props) => {
  const { name, ...rest } = props;

  const {
    field: { ref, ...inputProps },
  } = useController({ name });

  return (
    <PhoneNumberInput
      name={name}
      onChange={inputProps.onChange}
      value={inputProps.value}
      {...rest}
    />
  );
};
